import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Card } from "@mui/material";
import styles from "./AdminConfigPage.module.css";

interface Section {
  label: string;
  path: string;
}

const sections: Section[] = [
  { label: "Polos", path: "/adminconfigpage/polos" },
  { label: "Temáticas", path: "/adminconfigpage/tematicas" },
];

const AdminConfigPage: React.FC = () => {
  return (
    <div className={styles.container} data-testid="adminconfigpage">
      <Card className={styles.card}>
        <h1 className={styles.title}>Configurações do Administrador</h1>

        {/* Menu de Navegação */}
        <div className={styles.navMenu}>
          {sections.map((section, index) => (
            <NavLink
              key={index}
              to={section.path}
              className={({ isActive }) =>
                isActive ? styles.activeNavButton : styles.navButton
              }
            >
              {section.label}
            </NavLink>
          ))}
        </div>

        {/* Conteúdo da Página */}
        <div className={styles.pageContent}>
          <Outlet />
        </div>
      </Card>
    </div>
  );
};

export default AdminConfigPage;
